var option_webview_default = {
  "option": "KyGzy",
  "user_choice": "mdPHI",
  "check": "PMLqc",
  "image": "iiO8h",
  "input": "_3YzM0",
  "title": "_6mzsx",
  "centered": "_7O23V",
  "with_result": "ur9gG",
  "list": "rx8Dg",
  "with_image": "_4AvLN",
  "progress": "sXSGx",
  "progress_value": "_011EP",
  "label": "PTh9F",
  "cta": "B0c2c",
  "adornment_icon": "gQeJ5",
  "remove": "kcv6u",
  "removeButton": "laTRR",
  "removeButtonIcon": "ufQf-",
  "overlay": "oPQVU",
  "shown": "P9IBk",
  "dark": "KPcYZ",
  "spinner": "zmUfn",
  "spin": "pqrdt",
  "grid": "QR7mB"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
